import './assets/sass/theme.scss';
import 'core-js/es/map';
import 'core-js/es/object/assign';
import 'core-js/es/object/set-prototype-of';
import 'core-js/es/object/values';
import 'core-js/es/set';
import 'raf/polyfill'; 

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { initGTM } from './api';
import App from './app/App';
import { store } from './redux';
import * as serviceWorker from './serviceWorker';

initGTM();

ReactDOM.render(
  <Provider store={store}> 
    <App />
  </Provider>,
  document.getElementById('root') as HTMLElement
);

// register sw
serviceWorker.register({
  onUpdate: (registration) => {
    window.location.reload();
  },
});

// force an update check via navigator.serviceWorker.ready
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready
    .then((registration) => {
      return registration.update();
    })
    .catch((err) => {
      console.error('Service worker update check failed:', err);
    });
}